import { createFileRoute } from "@tanstack/react-router"
import { EventsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/events/all-events"
)({
  component: () => (
    <AuthorizationGate resource={Resource.EVENT} action={Action.READ}>
      <EventsPage />
    </AuthorizationGate>
  ),
})
